module.exports = __webpack_public_path__ + "img/main-banner-720.893fa2e5.jpg";